export const resources = {
  CognitiveInsightsInsightsTabTitle: 'Insights',
  Timeline: 'Timeline'
};
